"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomItemString = exports.eyesightList = void 0;
// Acronym because lazy
function TWGE(thing, plural) {
    return { name: thing, plural };
}
exports.eyesightList = [
    TWGE("Planes", true),
    TWGE("The MTA New York City Transit 7 Train", false),
    TWGE("Trees", true),
    TWGE("Clouds", true),
    TWGE("Building Antennae", true),
    TWGE("Buildings", true),
    TWGE("Smoke", false),
    TWGE("Keyboards", true),
    TWGE("Monitors", true),
    TWGE("Water Bottles", true),
    TWGE("Fire (from a gas stove)", false),
    TWGE("Rain", false),
    TWGE("The LaGuardiaLink Q70 Select Bus Service to LaGuardia Airport", false),
    TWGE("Baos", true)
];
function randomItem() {
    return exports.eyesightList[Math.floor(Math.random() * exports.eyesightList.length)];
}
function randomItemString() {
    const randomThing = randomItem();
    return `${randomThing.name} ${randomThing.plural ? "have" : "has"} great eyesight`;
}
exports.randomItemString = randomItemString;
exports.default = randomItem;
//# sourceMappingURL=index.js.map